import { ReactElement, useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';

type PortalType = {
  children?: ReactElement[] | ReactElement;
};

const Portal: React.FC<PortalType> = ({ children }) => {
  const mount = document.getElementById('portal-root');
  // Stable DOM node across renders — otherwise every parent re-render swaps
  // the container and CSS mount-animations re-fire (popup "refreshes").
  const elRef = useRef<HTMLDivElement | null>(null);
  if (!elRef.current) {
    elRef.current = document.createElement('div');
  }
  const el = elRef.current;

  useEffect(() => {
    if (!mount) return undefined;
    mount.appendChild(el);
    el.style.pointerEvents = 'initial';
    el.style.width = '100%';
    el.style.height = '100%';
    el.style.background = 'transparent';
    return () => {
      mount.removeChild(el);
    };
  }, [el, mount]);

  return createPortal(children, el);
};

export default Portal;
